var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsaFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 19,
    viewBox: "0 0 28 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0609 1.56446C27.0609 0.997793 26.5564 0.538818 25.9334 0.538818H11.2754V10.7952H0V17.9747C0 18.5414 0.504574 19.0004 1.12754 19.0004H25.9334C26.5564 19.0004 27.0609 18.5414 27.0609 17.9747V1.56446Z",
    fill: "#B41F30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0629 2.59009H11.2773V4.64137H27.0629V2.59009Z",
    fill: "#E6E6E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0629 6.69263H11.2773V8.74391H27.0629V6.69263Z",
    fill: "#E6E6E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.7952V12.8464H27.0609V10.7952H11.2754H0Z",
    fill: "#E6E6E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0609 14.8979H0V16.9492H27.0609V14.8979Z",
    fill: "#E6E6E6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2754 10.7952H0V1.56446C0 0.997793 0.504574 0.538818 1.12754 0.538818H11.2754V10.7952Z",
    fill: "#00256A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.63642 4.60132L5.27955 5.30286H4.43164L5.05179 5.88747L4.8229 6.7326L5.63642 6.31311L6.44994 6.7326L6.22104 5.88747L6.84119 5.30286H5.99215L5.63642 4.60132Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.87609 2.09253L2.51978 2.79407H1.67188L2.29146 3.37868L2.06257 4.22381L2.87609 3.80432L3.69017 4.22381L3.46072 3.37868L4.08086 2.79407H3.23183L2.87609 2.09253Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39813 2.09253L8.75444 2.79407H9.60235L8.98276 3.37868L9.21165 4.22381L8.39813 3.80432L7.58405 4.22381L7.81351 3.37868L7.19336 2.79407H8.0424L8.39813 2.09253Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.87609 9.24139L2.51978 8.53985H1.67188L2.29146 7.95523L2.06257 7.11011L2.87609 7.52959L3.69017 7.11011L3.46072 7.95523L4.08086 8.53985H3.23183L2.87609 9.24139Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39813 9.24139L8.75444 8.53985H9.60235L8.98276 7.95523L9.21165 7.11011L8.39813 7.52959L7.58405 7.11011L7.81351 7.95523L7.19336 8.53985H8.0424L8.39813 9.24139Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsaFlag);
export default __webpack_public_path__ + "static/media/usa-flag.4c43875938541082a1d610314bf7eeb9.svg";
export { ForwardRef as ReactComponent };